import Prism from 'prism-react-renderer/prism';

(typeof global !== 'undefined' ? global : window).Prism = Prism;

Prism.languages.alfa = {
  comment: [
    {
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: true,
      greedy: true
    },
    {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: true,
      greedy: true
    }
  ],
  string: {
    pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
    greedy: true
  },
  keyword: {
    pattern:
      /(\s|\.|^)(?:namespace|policy|policyset|rule|policyCombinator|ruleCombinator|permit|deny|apply|target|clause|and|or|import|condition|on|attribute|category|id|type|issuer|infix|allowbags|comm|inv|function|bag|anyAtomicOrBag|obligation|advice|mustbepresent|true|false)\b/i,
    lookbehind: true
  }
};
